export default "/fonts/vendor/primereact/resources/themes/lara-light-indigo/Inter-italic.var.woff2?30807be7abc48ba8c73c5e971fc46438";